let backendConfig;

const devConfig = {
  COGNITO_REGION: "us-west-2",
  APP_SYNC_REGION: "us-east-1",
  USER_POOL_ID: "us-west-2_AeqtVSzAc",
  APP_CLIENT_ID: "4sephkbrhnldjlthuk0j6mmu48",
  graphqlEndpoint:
    "https://zi4ij6stbjfulnrspwoghf4g2q.appsync-api.us-east-1.amazonaws.com/graphql",
  authType: "AMAZON_COGNITO_USER_POOLS",
};

/*const oldqaConfig = {
  COGNITO_REGION: 'us-west-2',
  APP_SYNC_REGION: 'us-east-1',
  USER_POOL_ID: 'us-west-2_3KT9H81HZ',
  APP_CLIENT_ID: '671hl8ngotbt8oih5e09spljas',
  graphqlEndpoint: 'https://v2zbrkiykrc3jh2c655dmcd33q.appsync-api.us-east-1.amazonaws.com/graphql',
  authType: 'AMAZON_COGNITO_USER_POOLS'
}*/

const prodConfig = {
  COGNITO_REGION: "us-west-2",
  APP_SYNC_REGION: "us-west-2",
  USER_POOL_ID: "us-west-2_RJQt0xbxl",
  APP_CLIENT_ID: "4rcdislttgdbup3j3ftom3tfer",
  graphqlEndpoint:
    "https://e6i5d3hhavfgbnzhskshc3wn3e.appsync-api.us-west-2.amazonaws.com/graphql",
  authType: "AMAZON_COGNITO_USER_POOLS",
};

const prod3Config = {
  COGNITO_REGION: "us-west-2",
  APP_SYNC_REGION: "us-west-2",
  USER_POOL_ID: "us-west-2_RJQt0xbxl",
  APP_CLIENT_ID: "4rcdislttgdbup3j3ftom3tfer",
  graphqlEndpoint:
    "https://pzg4taorrnf57gpbai7jrg3p24.appsync-api.us-west-2.amazonaws.com/graphql",
  authType: "AMAZON_COGNITO_USER_POOLS",
};

const qaConfig = {
  COGNITO_REGION: 'us-east-2',
  APP_SYNC_REGION: 'us-east-2',
  USER_POOL_ID: 'us-west-2_3KT9H81HZ',
  APP_CLIENT_ID: '671hl8ngotbt8oih5e09spljas',
  graphqlEndpoint: 'https://4yzjqr3oibcfjpvc4vg7hv6cie.appsync-api.us-east-2.amazonaws.com/graphql',
  authType: 'AMAZON_COGNITO_USER_POOLS'  
}

const demoConfig = {
  COGNITO_REGION: "us-west-2",
  APP_SYNC_REGION: "us-west-2",
  USER_POOL_ID: "us-west-2_UbtksUOZw",
  APP_CLIENT_ID: "6mmq9bpdq0ibie62nb4vei4qlr",
  graphqlEndpoint:
    "https://73ihp73xkngdnig7tfz4nt2scy.appsync-api.us-east-1.amazonaws.com/graphql",
  authType: "AMAZON_COGNITO_USER_POOLS",
};

backendConfig =
  process.env.REACT_APP_ENV === "prod"
    ? prodConfig
    : process.env.REACT_APP_ENV === "qa"
    ? qaConfig
    : process.env.REACT_APP_ENV === "demo"
    ? demoConfig
    : devConfig;

export default {
  s3: {
    REGION: "us-east-2",
    BUCKET: "posture-app-client",
  },
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://fz25u99nq5.execute-api.us-east-2.amazonaws.com/dev",
    APIKEY: "da2-xtbjknygrzdork7ztl4k4f3bti",
  },
  cognito: backendConfig,
  STRIPE_KEY:
    process.env.REACT_APP_ENV === "prod"
      ? "pk_live_A3RU6sRwShycVQt62uGEaveU"
      : "pk_test_HalXOUjXBqBmtTcvatMI8pxa",
};



// WEBPACK FOOTER //
// ./src/config.js